import { Dispatch } from 'redux';
import { requestBot } from '../../lib/request';

export const GET_SERVICES_REQUEST = 'SERVICES_GET_SERVICES_REQUEST';
export const GET_SERVICES_RESPONSE = 'SERVICES_GET_SERVICES_RESPONSE';
export const GET_SERVICES_ERROR = 'SERVICES_GET_SERVICES_ERROR';

export const getServicesAction = (userId: string, channelId: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_SERVICES_REQUEST,
    });
    const authString: any = localStorage.getItem('auth');
    const auth: any = JSON.parse(authString);

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/services?user_id=${userId}&channel_id=${channelId}`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${auth.access_token}`,
        }),
    }).then(response => dispatch({
        type: GET_SERVICES_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: GET_SERVICES_ERROR,
        error,
    }));
};



// WEBPACK FOOTER //
// ./src/actions/Services/services.ts